<template>
  <Categories v-if="isCategories" class="categories" @clicked="offCategories"/>
  <div class="header" v-else>
    <a href="https://polskieradio24.pl/" target="blank">
      <Logo class="icon header__logo" v-bind:style="{ fill: colorIcons }" />
    </a>

    <div class="header__icons">
      <router-link to="/">
        <Home class="icon header__home" v-bind:style="{ fill: colorIcons }" />
      </router-link>
      <Menu
        class="icon header__menu"
        v-bind:style="{ fill: colorIcons }"
        v-on:click="isCategories = !isCategories"
      />
    </div>
  </div>
</template>

<script>
import Categories from "../Categories/Categories";

import Logo from "./partials/logo.svg";
import Home from "./partials/home.svg";
import Menu from "./partials/menu.svg";

export default {
  name: "Header",
  data() {
    return {
      isCategories: false
    };
  },
  props: ["colorIcons"],
  methods: {
    offCategories(){
      this.isCategories = false
    }
  },
  components: {
    Logo,
    Home,
    Menu,
    Categories
  }
};
</script>

<style lang="scss" >
.categories {
  position: absolute;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  z-index: 5;
}

.header {
  height: 5rem;
  position: absolute;
  z-index: 1;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .icon {
    fill: white;
    cursor: pointer;
  }

  &__icons {
    margin-right: 2.5rem;
    width: 6rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &__logo {
    width: 4.8rem;
    height: 2rem;
    margin-left: 2.5rem;
  }

  &__home {
    width: 2rem;
    height: 1.9rem;
  }
  &__menu {
    width: 2rem;
    height: 1.9rem;
  }
}
</style>
